import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Moment from "react-moment";
import { Spin, Card } from "antd";
import { CardTitle, Button } from "reactstrap";
import { Divider } from "antd";
import Currency from "react-currency-formatter";
import { Form } from "antd";
import { useHistory } from 'react-router-dom'

//Actions
import {
  getSingleOffers,
  getSingleOffersCleanup,
} from "../../../store/actions/get-single-offer";

const OffersDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const getSingleOfferState = useSelector((s) => s.getSingleOffer);
  const [data, setData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    dispatch(getSingleOffers(1, id));
  }, []);

  useEffect(() => {
    if (getSingleOfferState.isSuccessful) {
      setData(getSingleOfferState.data[0]);
      dispatch(getSingleOffersCleanup());
    } else if (getSingleOfferState.error) {
      dispatch(getSingleOffersCleanup());
    }
  }, [getSingleOfferState]);

  const handleGenerateReport = (values) => {        
    if(data && data.Opportunity__r && data.Opportunity__r.EXPRN__Bin_formula__c && data.Opportunity__r.AccountId){
      console.log('MRA handleGenerateReport:', data.Opportunity__r.AccountId);
      history.push(`/withhansa?accountid=${data.Opportunity__r.AccountId}`);
    }     
  };

  return (
    <div className="pt-5  container advance-details-page">
      <div className="pt-5 table-container">
        <Card>
          <CardTitle className="text-cente p-4">
            <div className="sos-text-primary mb-0 font-weight-bold d-flex justify-content-between">
              <div>Offer</div>
            </div>
          </CardTitle>
        </Card>
        {/*
        <hr />
          { data && data.Opportunity__r && data.Opportunity__r.EXPRN__Bin_formula__c ?
          (<Card>
            <CardTitle className="text-cente p-4">            
              <div className="sos-text-primary mb-0 font-weight-bold d-flex justify-content-between">
                <div>WithHansa - Business identifier (EIN) : {data && data.Opportunity__r && data.Opportunity__r.EXPRN__Bin_formula__c}</div>
                  <Form
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="generate-report"
                          onFinish={handleGenerateReport}
                          className="p-4 justify-content-center"
                          layout="inline"
                        >
                    <Form.Item>
                        <Button htmlType="submit" className="sos-bg-primary text-white">Generate Report</Button>
                    </Form.Item>
                  </Form>             
              </div>
            </CardTitle>
          </Card>)
          :null}
        */}
        <hr />
        <Card>
          {getSingleOfferState.isLoading && !data ? (
            <Spin size="large" className="loader" />
          ) : data ? (
            <div>
              <Divider orientation="left">
                <h4 className="sos-font-weight-600 mt-0 mb-0">Information</h4>
              </Divider>
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Deal Type: </strong>
                    {data.Deal_Type__c}
                  </p>
                  <p>
                    <strong>Funding Amount: </strong>
                    <Currency
                      quantity={data.Amount__c === null ? 0 : data.Amount__c}
                      currency="USD"
                    />
                  </p>

                  <p>
                    <strong>Purchase Amount: </strong>
                    <Currency
                      quantity={
                        data.Purchase_Amount__c === null
                          ? 0
                          : data.Purchase_Amount__c
                      }
                      currency="USD"
                    />
                  </p>
                  <p>
                    <strong>Term (Months): </strong>
                    {data.Term_Months__c}
                  </p>

                  <p>
                    <strong>Holdback %: </strong>
                    {data.Holdback__c}
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>Daily Debit Amount: </strong>
                    <Currency
                      quantity={
                        data.Daily_PB_Amount__c === null
                          ? 0
                          : data.Daily_PB_Amount__c
                      }
                      currency="USD"
                    />
                  </p>
                  <p>
                    <strong>PMT Schedule: </strong>
                    {data.PMT_Schedule__c}
                  </p>
                  <p>
                    <strong>Approval Date: </strong>
                    {data.Approval_Date__c ? (
                      <Moment format="MMMM Do, YYYY">
                        {" "}
                        {data.Approval_Date__c}
                      </Moment>
                    ) : null}
                  </p>

                  <p>
                    <strong>Payback Amount: </strong>
                    <Currency
                      quantity={
                        data.Payback_Amt__c === null ? 0 : data.Payback_Amt__c
                      }
                      currency="USD"
                    />
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <h4>Offer not found</h4>
          )}
        </Card>
      </div>
    </div>
  );
};

export default OffersDetails;
